import React from 'react';
import { Typography } from '@equinor/opt-ui-core';
import { Block, Container, ScrollableContent } from 'Widgets/ui';
// Component
const SupportPage = () => (React.createElement(Container, null,
    React.createElement(ScrollableContent, null,
        React.createElement(Block, { maxWidth: "1080px", margin: "40px auto", textAlign: "center", px: "20px" },
            React.createElement(Block, null,
                React.createElement(Typography, { variant: "h2" }, "Support"),
                React.createElement(Typography, { mt: "30px" }, "For first line support, contact a Super User or SME in the monitoring team. This is an engineer currently working in the IOC Machine Learning pod."),
                React.createElement(Typography, { mt: "20px" }, "For second line support, please join the Slack channel omnia-prevent-support and report any inquiries."))))));
export default SupportPage;
